import { useSearchParams } from 'react-router-dom';
import { useOurCompany } from 'hooks/portal-settings.hook';
import { LegalEntityUrlParamsFilter } from 'entities/filters/legal-entity-url-params-filter';
import { BankAccountUrlParamsFilter } from 'entities/filters/bank-account-url-params-filter';
import { FilterWrapper, ValueFormatterContext } from 'shared/ui/filter/filter-wrapper';
import { useBankAccountsDropdown } from 'hooks/bank-accounts.hook';
import { useLegalEntityLabel } from 'shared/hooks/use-entity-labels';

export const PayOrdersExportFilter = () => {
  const ourCompanyId = useOurCompany();
  const bankAccounts = useBankAccountsDropdown();
  const [searchParams] = useSearchParams();
  const selectedLegalEntityId = searchParams.get('ourLegalEntityId');
  const legalEntityLabel = useLegalEntityLabel(selectedLegalEntityId);

  const BANK_ACCOUNTS = bankAccounts.items.map((item) => ({ label: item.title, id: item.id }));

  const createOptionFormatter = (options: { id: number | string; label: string }[]) => {
    const map = new Map(options.map((item) => [String(item.id), item.label]));
    return ({ value }: ValueFormatterContext) => map.get(String(value)) ?? value;
  };

  const bankAccountFormatter = createOptionFormatter(BANK_ACCOUNTS);

  const legalEntityValueFormatter = ({ value }: ValueFormatterContext) => {
    if (legalEntityLabel && selectedLegalEntityId === value) {
      return legalEntityLabel;
    }
    return value;
  };

  return (
    <FilterWrapper title="Фильтры экспорта">
      <FilterWrapper.Item label="Расчетный счет" queryKeys="bankAccountId" valueFormatter={bankAccountFormatter}>
        <BankAccountUrlParamsFilter queryParamName={'bankAccountId'} />
      </FilterWrapper.Item>

      <FilterWrapper.Item label="Наше юр. лицо" queryKeys="ourLegalEntityId" valueFormatter={legalEntityValueFormatter}>
        <LegalEntityUrlParamsFilter queryParamName={'ourLegalEntityId'} companyIdFilter={ourCompanyId} label={'Наше юр. лицо'} />
      </FilterWrapper.Item>
    </FilterWrapper>
  );
};
